import { CRating } from './CRating.js';

const CRatingPlugin = {
    install: (app) => {
        app.component(CRating.name, CRating);
    },
};

export { CRating, CRatingPlugin };
//# sourceMappingURL=index.js.map
